export default "__VITE_ASSET__03390ee4__"